"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryName = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function getCountryName(iso_code) {
    var _a;
    const { country_info } = (0, checkout_frontend_library_1.getOrderInitialData)();
    const countryInfo = country_info.find(o => o.iso_code === iso_code);
    return (_a = countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.name) !== null && _a !== void 0 ? _a : '';
}
exports.getCountryName = getCountryName;
